import { cn } from '@/lib/utils'
import { FloatLabel } from '../float-label'

export type InputProps = React.ComponentProps<'input'> & {
  variant?: 'default' | 'floating' | 'labelUp'
  label?: string
  onlyInputClassName?: string
}

export function Input({
  className,
  onlyInputClassName,
  variant = 'default',
  type = 'text',
  label,
  value,
  onBlurCapture,
  ...props
}: InputProps) {
  return (
    <FloatLabel
      label={label}
      variant={variant}
      hasValue={!!value && `${value}`.trim() !== ''}
    >
      <input
        type={type}
        data-slot="input"
        onBlurCapture={onBlurCapture}
        value={value}
        placeholder={variant === 'floating' ? props.placeholder : ''}
        className={cn(
          'file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
          'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[1px]',
          'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
          className,
          onlyInputClassName,
        )}
        {...props}
      />
    </FloatLabel>
  )
}
